export const NO_REFERRER_URL = 'no-referrer-found';
